import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function H() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    const { locale } = useRouter();
    let lists: any[] = [
        {
            title: 'secH_q1',
            descp: 'secH_a1',
        },
        {
            title: 'secH_q2',
            descp: 'secH_a2',
        },
        {
            title: 'secH_q3',
            descp: 'secH_a3',
        },
        {
            title: 'secH_q4',
            descp: 'secH_a4',
        },
        {
            title: 'secH_q5',
            descp: 'secH_a5',
        },
        {
            title: 'secH_q6',
            descp: 'secH_a6',
        },
        {
            title: 'secH_q7',
            descp: 'secH_a7',
        },
        {
            title: 'secH_q8',
            descp: 'secH_a8',
        },
        {
            title: 'secH_q9',
            descp: 'secH_a9',
        },
        // {
        //     title: 'secH_q10',
        //     descp: 'secH_a10',
        // },
        {
            title: 'secH_q11',
            descp: 'secH_a11',
        },
        {
            title: 'secH_q12',
            descp: 'secH_a12',
        },
        {
            title: 'secH_q13',
            descp: 'secH_a13',
        },
        {
            title: 'secH_q14',
            descp: 'secH_a14',
        },
        {
            title: 'secH_q15',
            descp: 'secH_a15',
        },
    ];

    if (locale === 'jp') {
        lists = [
            {
                title: 'secH_q1',
                descp: 'secH_a1',
            },
            {
                title: 'secH_q2',
                descp: 'secH_a2',
            },
            {
                title: 'secH_q3',
                descp: 'secH_a3',
            },
            {
                title: 'secH_q4',
                descp: 'secH_a4',
            },
            {
                title: 'secH_q5',
                descp: 'secH_a5',
            },
            {
                title: 'secH_q6',
                descp: 'secH_a6',
            },
            {
                title: 'secH_q7',
                descp: 'secH_a7',
            },
            {
                title: 'secH_q8',
                descp: 'secH_a8',
            },
            {
                title: 'secH_q9',
                descp: 'secH_a9',
            },
            {
                title: 'secH_q10',
                descp: 'secH_a10',
            },
            {
                title: 'secH_q11',
                descp: 'secH_a11',
            },
        ];
    }

    return (
        <div id="delta-pro-ultra-prelaunch-H" className={`delta-pro-ultra-H off-grid-box ${css['delta-pro-ultra-H']}`}>
            <div className="text-info">
                <h2 className="title">{t('secH_title')}</h2>
            </div>
            <Collapse
                ghost={true}
                className="collapse-lists"
                // defaultActiveKey={0}
                // onChange={setActive}
                // accordion={true}
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    );
                }}
                expandIconPosition="right"
            >
                {lists?.map((list: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={t(list.title)}>
                        <p className="list-desc">{t(list.descp)}</p>
                    </Collapse.Panel>
                ))}
            </Collapse>
        </div>
    );
}
